import FilterBar from "../../components/FilterBar";
import { TextField } from "@mui/material";
import { PartsFilters } from "./inventoryTypes";
import { filterConstraintChecker } from "./inventoryPartsUtils";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useHistory } from "react-router-dom";

interface Props {
  filters: PartsFilters;
  setFilters: React.Dispatch<any>;
  initialFilters: PartsFilters;
}

const LptRmaFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const history = useHistory();
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        children={(handler: (event: any) => void) => [
          <ToggleSwitch
            options={["Hardware", "Parts"]}
            onClicks={[
              () => {
                history.push("/inventory/hardware");
              },
              () => {
                history.push("/inventory/parts");
              },
            ]}
            startingOption="Parts"
          />,
          <TextField
            name="searchTerms"
            value={filters.searchTerms}
            onChange={handler}
            label="Filter By Name"
            variant="outlined"
          ></TextField>,
        ]}
      />
    </>
  );
};

export default LptRmaFilterBar;
